import { render, staticRenderFns } from "./ExtractedDetails.vue?vue&type=template&id=7b1465ea&scoped=true"
import script from "./ExtractedDetails.vue?vue&type=script&lang=js"
export * from "./ExtractedDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtractedDetails.vue?vue&type=style&index=0&id=7b1465ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1465ea",
  null
  
)

export default component.exports